import { c as _c } from "react/compiler-runtime";
import { ApiCreateGroupDescription } from "@/generated/models/ApiCreateGroupDescription";
import GroupCreateNumericValue from "./common/GroupCreateNumericValue";
export default function GroupCreateLevel(t0) {
  const $ = _c(7);
  const {
    level,
    setLevel
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-mb-4"><p className="tw-mb-0 tw-text-lg tw-font-semibold tw-text-iron-100">Level</p><p className="tw-mt-1 tw-mb-0 tw-text-sm tw-font-normal tw-text-iron-300">Set the group's minimum level requirement.</p></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== level || $[2] !== setLevel) {
    t2 = value => setLevel({
      ...level,
      min: value
    });
    $[1] = level;
    $[2] = setLevel;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== level.min || $[5] !== t2) {
    t3 = <div className="tw-p-3 sm:tw-p-5 tw-bg-iron-950 tw-rounded-xl tw-shadow tw-border tw-border-solid tw-border-iron-800">{t1}<GroupCreateNumericValue value={level.min} label="Level at least" labelId="floating_level" setValue={t2} /></div>;
    $[4] = level.min;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}